var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5867 20.8219C16.6358 20.8219 16.6855 20.8097 16.7303 20.7855C16.8285 20.7328 16.8897 20.6297 16.8897 20.5188V16.2013C19.5424 14.8219 21 12.4067 21 9.38065C21 4.70428 16.7012 1.17822 11 1.17822C5.29879 1.17822 0.999999 4.70428 0.999999 9.38065C0.999999 14.0564 5.29879 17.5825 11 17.5825C11.1873 17.5825 11.3709 17.5722 11.5552 17.5625L11.5673 17.5619L16.42 20.7716C16.4703 20.8049 16.5285 20.8219 16.5867 20.8219ZM11 1.78428C16.3552 1.78428 20.3939 5.05034 20.3939 9.38065C20.3939 11.3946 19.7103 14.1334 16.4527 15.7437C16.3497 15.7946 16.2842 15.9 16.2842 16.0152V19.9552L11.8182 17.0013C11.7636 16.9649 11.6976 16.9437 11.6352 16.9516L11.5224 16.9576C11.3491 16.9673 11.1764 16.9764 11.0006 16.9764C5.64545 16.9764 1.60667 13.711 1.60667 9.38065C1.60667 5.05034 5.64485 1.78428 11 1.78428Z",
    fill: "black",
    stroke: "#393E46",
    strokeWidth: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.61dcf40310ba2fa33649488cfa013635.svg";
export { ForwardRef as ReactComponent };